// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_Separator__QlylF","SeparatorItem":"Separator_SeparatorItem__9MUkD"};